import React from 'react';

import WpContextMenu from '../WpContextMenu';
import { WpMenu, WpMenuItem } from 'Wpds/components/menu';

const ContextMenuDocs = () => {
  return (
    <div>
      <WpContextMenu
        menu={
          <WpMenu>
            <WpMenuItem>Edit</WpMenuItem>
            <WpMenuItem>Copy</WpMenuItem>
            <WpMenuItem>Delete</WpMenuItem>
          </WpMenu>
        }
      >
        <>right click on me</>
      </WpContextMenu>
    </div>
  );
};

export default ContextMenuDocs;
